@use '../scss/abstracts/mixins' as *;
@use '../scss/abstracts/variables' as *;

.container {
  background-color: #f3ecdf;
  border-bottom: 1px solid #ddd4c2;
  display: flex;
  overflow-x: auto;
  padding: 1.4rem 4rem;
  align-items: center;

  @media screen and (max-width: $phone) {
    padding: 1.4rem 2rem;
  }
}

.breadcrumb {
  font-family: 'Inter', sans-serif;
  font-size: 1.1rem;
  color: #6d6655;
  vertical-align: middle;
  white-space: nowrap;
  display: flex;
  align-items: center;

  &:not(:last-child)::after {
    content: '\203A';
    display: inline-block;
    margin: 0 1rem;
    color: #6d6655;
  }

  &.active {
    font-weight: 700;
    color: #2b2820;
    pointer-events: none;
  }

  a {
    font-family: 'Inter', sans-serif;
    font-size: 1.1rem;
    line-height: 1.18;
    color: #6d6655 !important;
    text-decoration: none;

    &:hover {
      color: #bf8a2e !important;
    }
  }
}
